import { Table } from "@project/shared"

import { t } from "i18next"
import { DefaultProps } from "./types"
import {
  TABLE_HEADS,
  generateDynamicColumn,
  getTotalColumnInfo,
  padEmptyFacilities,
} from "./utils"
import { NBLManagementCompanyTop } from "../../PrintListContent.style"

type Props = DefaultProps

function bodyOnCell(_, index: number) {
  if (index === 0) {
    return { rowSpan: 8 }
  }
  return { rowSpan: 0 }
}

export function DefaultFormat({
  facilities,
  totalAmount,
  totalBurdenAmount,
  managementResultBurdenAmount,
  printConfig,
}: Props) {
  const upperRow = padEmptyFacilities(facilities.slice(0, 5), 5)
  const lowerRow = padEmptyFacilities(facilities.slice(5, 9), 4)

  return (
    <>
      <NBLManagementCompanyTop>
        <div className={"NBLManagementCompanyTop"}>
          <Table
            showHeader={false}
            columns={[
              {
                title: "",
                render: () =>
                  t("User burden amount aggregation / adjustment column"),
                width: 20,
                onCell: bodyOnCell,
              },
              {
                title: "",
                dataIndex: "title",
                align: "center",
                width: 200,
              },
              ...generateDynamicColumn(upperRow, printConfig),
            ]}
            pagination={false}
            dataSource={TABLE_HEADS}
          />
        </div>
      </NBLManagementCompanyTop>

      <NBLManagementCompanyTop>
        <div className={"NBLManagementCompanyTop"}>
          <Table
            showHeader={false}
            columns={[
              {
                title: "",
                render: () =>
                  t("User burden amount aggregation / adjustment column"),
                width: 20,
                onCell: bodyOnCell,
              },
              {
                title: "",
                dataIndex: "title",
                align: "center",
                width: 200,
              },
              ...generateDynamicColumn(lowerRow, printConfig),
              // 最終列（合計）
              {
                title: t("Total"),
                align: "center",
                width: 180,
                render: (_, __, index) =>
                  getTotalColumnInfo(
                    totalAmount,
                    totalBurdenAmount,
                    managementResultBurdenAmount,
                    index
                  ),
                onCell: (_, index) => {
                  if (index === 0) {
                    return { rowSpan: 5 }
                  }
                  if ([1, 2, 3, 4].includes(index)) {
                    return { rowSpan: 0 }
                  }
                  return {}
                },
              },
            ]}
            pagination={false}
            dataSource={TABLE_HEADS}
          />
        </div>
      </NBLManagementCompanyTop>
    </>
  )
}
